module.exports = {"components.errorMessage.message.default":"Ein unerwarteter Fehler ist aufgetreten.","components.errorMessage.reload.buttonLabel":"neu laden","components.errorMessage.message.contentItem1":"Bitte","components.errorMessage.message.contentItem2":"die Seite"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/de/components/ErrorMessage.json
// module id = 865
// module chunks = 0